<script>
  import DataAPI from 'components/Config/DataAPI.svelte'
  import Octicon from 'components/primer/Octicon.svelte'
  import { apiUrl, datasets, init, view } from 'modules/stores.js'

  const toGridify = () => {
    $view = 'gridify'
  }
</script>

<style global type="text/scss">

</style>

<div class="container-md">
  <div class="d-flex flex-column p-3 ">
    <div class="pagehead">
      <h1 class="h4">
        <button
          type="button"
          class="btn-link"
          title="Go back to Gridify app"
          on:click|preventDefault={toGridify}>
          <Octicon symbol="chevron-left" />
          Gridify
        </button>
      </h1>
      <h2 class="h1">Settings</h2>
    </div>
  </div>

  <section class="settings mx-3 px-1">
    <DataAPI />
  </section>
</div>
